import React, { useEffect, useRef } from 'react';

// Define an interface for the component props
interface PSBannerWrapperProps {
  id?: string;
  message: string; // Assuming message is required
  level?: string;
  extraClass?: string;
  icon?: boolean; // Correct type for 'icon' as you've described it should be a boolean
}
// Apply the interface to your component function
export const PSBannerWrapper: React.FC<PSBannerWrapperProps> = ({
  id,
  message,
  level,
  extraClass,
  icon,
}) => {
  const bannerRef = useRef<HTMLElement>(null);

  // Update custom element attributes when props change
  useEffect(() => {
    if (bannerRef.current) {
      if (id) {
        bannerRef.current.setAttribute('id', id);
      }
      if (message) {
        bannerRef.current.setAttribute('message', message);
      }
      if (level) {
        bannerRef.current.setAttribute('level', level);
      }
      if (extraClass) {
        bannerRef.current.setAttribute('extra-class', extraClass);
      }
      if (icon) {
        bannerRef.current.setAttribute('icon', '');
      } else {
        bannerRef.current.removeAttribute('icon');
      }
    }
  }, [id, message, level, extraClass, icon]);

  return <ps-banner ref={bannerRef}></ps-banner>;
};
// written with AI assistance
